export default __webpack_public_path__ + "static/media/AX.75d05f60.svg";